import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step12 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("gender");

  const handleOptionClick = (value) => {
    onAnswer("gender", value);
  };

  return (
    <div className="quizContentWrapper">
      <QuizContent>
        <QuizTitle>
          What gender would you prefer your AI friend to be?
        </QuizTitle>
        <QuizOptions>
          {quizOptions.map((option) => (
            <QuizOption
              key={option.value}
              value={option.value}
              name="gender"
              onClick={handleOptionClick}
            >
              <div>
                <p>
                  <strong>{option.text}</strong>
                </p>
              </div>
            </QuizOption>
          ))}
        </QuizOptions>
      </QuizContent>
    </div>
  );
};

export default Step12;
